import { useState, useEffect } from 'react';

function useScript(src) {
  const [status, setStatus] = useState(src ? 'loading' : 'idle');

  useEffect(() => {
    if (!src) {
      setStatus('idle');
      return;
    }

    // Check if script is already present in the document.
    let script = document.querySelector(`script[src="${src}"]`);
    if (!script) {
      // Create script
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.id = 'adsbygoogle-script';
      document.head.appendChild(script);

      const onScriptLoad = () => setStatus('ready');
      const onScriptError = () => {
        script.remove();
        setStatus('error');
      };

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError);

      return () => {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);
      };
    } else {
      setStatus('ready');
    }
  }, [src]);

  return status;
}

export default useScript;
